import request from '../../api/request'
let orderAction = {
    getRobotDoc: (param,cbk) => {
        request.getRobotDoc(param).then(result => {
            console.log(result)
            if(result.code === 200){
                document.title = result.data.docQuestion;
                cbk&&cbk(result.data.docAnswer)
            }else{
                this.$message.error(result.message)
            }
        })
    }

}
export default orderAction



// WEBPACK FOOTER //
// ./src/components/question/index.js